import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import {
    getOIDCDataFromServer,
    addOIDCDataToServer,
    updateOIDCDataToServer,
    deleteOIDCDataToServer,
} from "./msgs/oidcIdentityProviderAPICallers";
import {
    AddOidcIdentityProvider,
    UpdateOidcIdentityProvider,
    DeleteOidcIdentityProvider,
    OidcIdentityProviders,
    initOidcData,
} from "userful-chronos-app-common-js/dist/models/usermgt/oidcIdentityProviders";

export interface InitialStateOIDC {
    oidcData: OidcIdentityProviders;
    loadBool: boolean;
    saveBool: boolean;
    overlay: boolean;
}

const initialStateOIDC: InitialStateOIDC = {
    oidcData: initOidcData(),
    loadBool: true,
    saveBool: false,
    overlay: false,
};

export const oidcIdentityProviderSlice = createSlice({
    name: "oidcIdentityProviderSlice",
    initialState: initialStateOIDC,
    reducers: {
        getOIDCDataFromServer: (state, action: PayloadAction<{}>) => {
            getOIDCDataFromServer(getGlobalStates().keycloak.token);
        },
        setOIDCData: (state, action: PayloadAction<OidcIdentityProviders>) => {
            state.oidcData = action.payload;
        },
        setLoadBool: (state, action: PayloadAction<boolean>) => {
            state.loadBool = action.payload;
        },
        addOIDCDataToServer: (state, action: PayloadAction<AddOidcIdentityProvider>) => {
            state.saveBool = true;
            addOIDCDataToServer(getGlobalStates().keycloak.token, action.payload);
        },
        updateOIDCDataToServer: (state, action: PayloadAction<UpdateOidcIdentityProvider>) => {
            state.saveBool = true;
            updateOIDCDataToServer(getGlobalStates().keycloak.token, action.payload);
        },
        deleteOIDCDataToServer: (state, action: PayloadAction<DeleteOidcIdentityProvider>) => {
            state.saveBool = true;
            deleteOIDCDataToServer(getGlobalStates().keycloak.token, action.payload);
        },
        setSaveBool: (state, action: PayloadAction<boolean>) => {
            state.saveBool = action.payload;
        },
        setOverlay: (state, action: PayloadAction<boolean>) => {
            state.overlay = action.payload;
        },
    },
});

export const oidcIdentityProviderSliceActions = oidcIdentityProviderSlice.actions;

export default oidcIdentityProviderSlice.reducer;
